var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.48,
    height: 27.48,
    viewBox: "0 0 27.48 27.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "about-icon",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9477",
    "data-name": "Path 9477",
    d: "M22.02,11.8a1.46,1.46,0,1,1-1.46-1.46,1.46,1.46,0,0,1,1.46,1.46Zm-3.3,11.811,2.015-7.522c.373-1.392-1.764-1.966-3.146-1.3a5.368,5.368,0,0,0-2.13,1.858c.868-.381,2.807-1.244,2.1,1.387l-2.015,7.522c-.373,1.392,1.764,1.966,3.146,1.3A5.369,5.369,0,0,0,20.822,25C19.954,25.382,18.015,26.245,18.72,23.614ZM32.48,18.74A13.74,13.74,0,1,1,18.74,5,13.74,13.74,0,0,1,32.48,18.74Zm-1.527,0A12.213,12.213,0,1,0,18.74,30.953,12.213,12.213,0,0,0,30.953,18.74Z",
    transform: "translate(-1 -2)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu-2.0c8f4d9743bc2f8147e2bd86ef2e58a0.svg";
export { ForwardRef as ReactComponent };